export default {
  computed: {
    boardListsIds: {
      get() {
        if (this.isCardsLayoutTimeline && this.groupByStatus && !this.sprintSidebar) {
          return this.boardListsGroupedBy?.slice().reverse();
        }
        return this.boardListsGroupedBy;
      },
      set() {
        // This is intentional to make read-only computed
      },
    },

    boardListsGroupedBy() {
      if (
        !this.groupByStatus &&
        ([
          this.$constants.routeNames.board,
          this.$constants.epicsBoardRoute.name,
          this.$constants.epicRoute.name,
          this.$constants.routeNames.sprint,
        ].includes(this.$route.name) ||
          this.embed)
      ) {
        return this.boardListGroupByOrder;
      }

      return this.statusListIds;
    },

    boardsListSpaceHome: {
      get() {
        return this.$store.getters.boardsListsIds[this.board.id] || [];
      },
      set() {},
    },

    statusListIds() {
      return this.boardsListSpaceHome;
    },

    hideEmptyGroups() {
      return this.embed && !this.inEpicBoard
        ? this.embeddedBoardAttributes.hideEmptyGroups
        : this.$store.getters.getHideEmptyGroups(this.board.id);
    },

    sprintSidebar() {
      return this.embed && this.embeddedBoardAttributes?.sprintSidebar;
    },
  },

  methods: {
    updateBoardListsOrder({ oldPosition, position, listId, boardId = this.board.id }) {
      let calculatedOldPosition = oldPosition;
      let calculatedPosition = position;

      // This is for the case when timeline view is enabled
      if (this.isCardsLayoutTimeline && this.groupByStatus) {
        // We need to reverse the order of the list
        // as the list is reversed in the UI
        // and recalculate the position and oldPosition
        const listIdsLength = this.boardListsIds.length;
        calculatedOldPosition = listIdsLength - oldPosition - 1;
        calculatedPosition = listIdsLength - position - 1;
      }

      if (this.boardGroupBy !== 'status') {
        this.$store.dispatch('updateGroupByListOrder', {
          boardId,
          listId,
          newIndex: calculatedPosition,
          oldIndex: calculatedOldPosition,
        });
        return;
      }

      this.$store.dispatch('moveBoardListId', {
        boardId,
        listId,
        newIndex: calculatedPosition,
        oldIndex: calculatedOldPosition,
      });

      this.$store
        .dispatch('updateList', {
          boardId,
          listId,
          list: { position: calculatedPosition },
        })
        .catch(() => {
          this.$store.dispatch('moveBoardListId', {
            boardId,
            listId,
            newIndex: calculatedOldPosition,
            oldIndex: calculatedPosition,
          });
        });
    },
    boardListsChanged(evt) {
      if (evt.moved) {
        const { element, newIndex, oldIndex } = evt.moved;
        this.updateBoardListsOrder({
          oldPosition: oldIndex,
          position: newIndex,
          listId: element,
        });
      }
    },
  },
};
